import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var ArrowCRightIcon20Light = forwardRefAndName('ArrowCRightIcon20Light', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 20
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M7.021 3.396a.5.5 0 0 1 .708 0l4.836 4.836a2.5 2.5 0 0 1 0 3.536l-4.836 4.836a.5.5 0 1 1-.708-.707l4.836-4.836a1.5 1.5 0 0 0 0-2.122L7.021 4.104a.5.5 0 0 1 0-.708Z"
    }))
  );
});